import { getCurrentInstance as d, inject as C, computed as t, ref as g, unref as v, provide as x } from "vue";
import { configProviderContextKey as m } from "./index622.js";
import { useLocale as y, localeContextKey as I } from "./index597.js";
import { useNamespace as _, defaultNamespace as b, namespaceContextKey as z } from "./index559.js";
import { useZIndex as K, defaultInitialZIndex as G, zIndexContextKey as N } from "./index623.js";
import { SIZE_INJECTION_KEY as O } from "./index607.js";
import { emptyValuesContextKey as S } from "./index583.js";
import { debugWarn as E } from "./index588.js";
import { keysOf as f } from "./index624.js";
const s = g();
function p(r, u = void 0) {
  const o = d() ? C(m, s) : s;
  return r ? t(() => {
    var l, n;
    return (n = (l = o.value) == null ? void 0 : l[r]) != null ? n : u;
  }) : o;
}
function Y(r, u) {
  const o = p(), l = _(
    r,
    t(() => {
      var e;
      return ((e = o.value) == null ? void 0 : e.namespace) || b;
    })
  ), n = y(t(() => {
    var e;
    return (e = o.value) == null ? void 0 : e.locale;
  })), i = K(
    t(() => {
      var e;
      return ((e = o.value) == null ? void 0 : e.zIndex) || G;
    })
  ), a = t(() => {
    var e;
    return v(u) || ((e = o.value) == null ? void 0 : e.size) || "";
  });
  return V(t(() => v(o) || {})), {
    ns: l,
    locale: n,
    zIndex: i,
    size: a
  };
}
const V = (r, u, o = !1) => {
  var l;
  const n = !!d(), i = n ? p() : void 0, a = (l = void 0) != null ? l : n ? x : void 0;
  if (!a) {
    E(
      "provideGlobalConfig",
      "provideGlobalConfig() can only be used inside setup()."
    );
    return;
  }
  const e = t(() => {
    const c = v(r);
    return i?.value ? Z(i.value, c) : c;
  });
  return a(m, e), a(
    I,
    t(() => e.value.locale)
  ), a(
    z,
    t(() => e.value.namespace)
  ), a(
    N,
    t(() => e.value.zIndex)
  ), a(O, {
    size: t(() => e.value.size || "")
  }), a(
    S,
    t(() => ({
      emptyValues: e.value.emptyValues,
      valueOnClear: e.value.valueOnClear
    }))
  ), (o || !s.value) && (s.value = e.value), e;
}, Z = (r, u) => {
  const o = [.../* @__PURE__ */ new Set([...f(r), ...f(u)])], l = {};
  for (const n of o)
    l[n] = u[n] !== void 0 ? u[n] : r[n];
  return l;
};
export {
  V as provideGlobalConfig,
  Y as useGlobalComponentSettings,
  p as useGlobalConfig
};
